import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyInsuranceFormFieldTemplateClasses,
} from '@dxp-module/themes'

const fieldTemplateStyles = makeStyles<
  MyAccountTheme,
  object,
  MyInsuranceFormFieldTemplateClasses
>(
  ({ breakpoints }) => ({
    item: {
      width: '100%',
      padding: 0,
      margin: '5px 0',
      [breakpoints.down('sm')]: {
        padding: 0,
      },
    },
  }),
  { name: 'MyAccount_InsuranceForm_FieldTemplate' }
)

export default fieldTemplateStyles
